import { db } from '@/lib/firebase';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';

export interface ISMSRole {
  id: string;
  dateAdded: any;
  roleName: string;
  roleDescription: string;
}

export async function fetchISMSRoles(companyID: string): Promise<ISMSRole[]> {
  const docPath = `customers/${companyID}/product/policyPackages/ISO27001keyDocuments/ismsManual`;
  const docRef = doc(db, docPath);

  try {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data()?.ismsRoles;
      if (data && typeof data === 'object') {
        const ismsRoles: ISMSRole[] = Object.entries(data).map(([id, role]: [string, any]) => ({
          id,
          dateAdded: role.dateAdded,
          roleName: role.roleName,
          roleDescription: role.roleDescription,
        }));
        return ismsRoles;
      } else {
        return [];
      }
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching ISMS roles:', error);
    return [];
  }
}

export function onISMSRolesChange(companyID: string, callback: (roles: ISMSRole[]) => void): () => void {
  const docPath = `customers/${companyID}/product/policyPackages/ISO27001keyDocuments/ismsManual`;
  const docRef = doc(db, docPath);
  return onSnapshot(docRef, (docSnap) => {
    if (docSnap.exists()) {
      const data = docSnap.data()?.ismsRoles;
      if (data && typeof data === 'object') {
        const ismsRoles: ISMSRole[] = Object.entries(data).map(([id, role]: [string, any]) => ({
          id,
          dateAdded: role.dateAdded,
          roleName: role.roleName,
          roleDescription: role.roleDescription,
        }));
        callback(ismsRoles);
      } else {
        callback([]);
      }
    } else {
      callback([]);
    }
  });
}
